/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetRootMcpEndpointRequestBody,
  SetRootMcpEndpointRequestBody$Outbound,
  SetRootMcpEndpointRequestBody$outboundSchema,
} from "../components/setrootmcpendpointrequestbody.js";

export type SetRootMcpEndpointSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetRootMcpEndpointRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setRootMcpEndpointRequestBody: SetRootMcpEndpointRequestBody;
};

/** @internal */
export type SetRootMcpEndpointSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetRootMcpEndpointSecurity$outboundSchema: z.ZodMiniType<
  SetRootMcpEndpointSecurity$Outbound,
  SetRootMcpEndpointSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setRootMcpEndpointSecurityToJSON(
  setRootMcpEndpointSecurity: SetRootMcpEndpointSecurity,
): string {
  return JSON.stringify(
    SetRootMcpEndpointSecurity$outboundSchema.parse(setRootMcpEndpointSecurity),
  );
}

/** @internal */
export type SetRootMcpEndpointRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SetRootMcpEndpointRequestBody: SetRootMcpEndpointRequestBody$Outbound;
};

/** @internal */
export const SetRootMcpEndpointRequest$outboundSchema: z.ZodMiniType<
  SetRootMcpEndpointRequest$Outbound,
  SetRootMcpEndpointRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    setRootMcpEndpointRequestBody: SetRootMcpEndpointRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      setRootMcpEndpointRequestBody: "SetRootMcpEndpointRequestBody",
    });
  }),
);

export function setRootMcpEndpointRequestToJSON(
  setRootMcpEndpointRequest: SetRootMcpEndpointRequest,
): string {
  return JSON.stringify(
    SetRootMcpEndpointRequest$outboundSchema.parse(setRootMcpEndpointRequest),
  );
}
